/** Where a case's customer name goes (#548). An account id wins; a contact id is the fallback. */

export type PartyTarget = { kind: 'account'; id: string } | { kind: 'contact'; id: string }

function clean(value?: string | null): string | null {
  const text = value?.trim()
  return text ? text : null
}

export function accountTarget(deskAccountId?: string | null, conduitCustomerId?: string | null): PartyTarget | null {
  const id = clean(deskAccountId) ?? clean(conduitCustomerId)
  return id ? { kind: 'account', id } : null
}

export function contactTarget(contactId?: string | null): PartyTarget | null {
  const id = clean(contactId)
  return id ? { kind: 'contact', id } : null
}

/** Queue and All cases: a resolved account links to the account; an unresolved row links to the contact. */
export function casePartyTarget(row: {
  customer_display?: string | null
  desk_account_id?: string | null
  conduit_customer_id?: string | null
  contact_id?: string | null
}): PartyTarget | null {
  if (clean(row.customer_display)) return accountTarget(row.desk_account_id, row.conduit_customer_id)
  return contactTarget(row.contact_id)
}

/** Case header: the account when we have one, otherwise the contact. */
export function headerPartyTarget(row: {
  deskAccountId?: string | null
  conduitCustomerId?: string | null
  contactId?: string | null
}): PartyTarget | null {
  return accountTarget(row.deskAccountId, row.conduitCustomerId) ?? contactTarget(row.contactId)
}

export function partyPath(target: PartyTarget): string {
  const id = encodeURIComponent(target.id)
  return target.kind === 'account' ? `/accounts/${id}` : `/contacts/${id}`
}
